import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { dir: "rtl" }
const _hoisted_2 = {
  key: 0,
  style: {"font-size":"14px","color":"#3f3f3f","padding":"1rem 0rem","border-bottom":"1px solid #ececec"}
}
const _hoisted_3 = { class: "row mt-4" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "col-6" }

import { computed } from "vue";
import Dialog from "primevue/dialog";
import moment from "moment";

import { CharityRegisterInterfaces } from "@/interfaces/charity-register";


export default /*@__PURE__*/_defineComponent({
  __name: 'existing-request-modal',
  props: {
    display: { type: Boolean },
    charityRequest: {}
  },
  emits: ["reuse", "decline"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const createdOn = computed(() =>
  props.charityRequest?.created_on
    ? moment(props.charityRequest.created_on).format("YYYY-MM-DD")
    : ""
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: __props.display,
    closable: false,
    showHeader: false,
    modal: true,
    contentStyle: "padding:1.5rem 3rem"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          style: {"font-size":"18px","color":"#3f3f3f"},
          class: "mb-3"
        }, " يوجد بالفعل طلب تسجيل مرتبط بهذا البريد الإلكتروني، هل ترغب في المتابعة به؟ ", -1)),
        (__props.charityRequest)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, "اسم الجمعية : " + _toDisplayString(__props.charityRequest.charity_name), 1),
              _createElementVNode("div", null, "حالة الطلب : " + _toDisplayString(__props.charityRequest.status_label), 1),
              _createElementVNode("div", null, "تاريخ الطلب : " + _toDisplayString(createdOn.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              id: "existing-request-no-btn",
              class: "btn btn-lg btn-secondary btn-block close-btn",
              type: "button",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('decline')), ["stop"]))
            }, " لا ")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              id: "existing-request-yes-btn",
              class: "btn btn-lg btn-primary btn-block tracking-btn",
              type: "button",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('reuse')), ["stop"]))
            }, " نعم ")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})